import { render, staticRenderFns } from "./personalSettings.vue?vue&type=template&id=91c7de9c&scoped=true"
import script from "./personalSettings.vue?vue&type=script&lang=js"
export * from "./personalSettings.vue?vue&type=script&lang=js"
import style0 from "./personalSettings.vue?vue&type=style&index=0&id=91c7de9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c7de9c",
  null
  
)

export default component.exports